export const AGENT_FIELD_FORM_LIMITS = {
  name: 256,
  description: 50000,
  filter: 512,
  filterMax: 20,
};
